import { render, staticRenderFns } from "./atribuicao-estrategia.vue?vue&type=template&id=3c39f5b2&scoped=true&"
import script from "./atribuicao-estrategia.vue?vue&type=script&lang=js&"
export * from "./atribuicao-estrategia.vue?vue&type=script&lang=js&"
import style0 from "./atribuicao-estrategia.vue?vue&type=style&index=0&id=3c39f5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39f5b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c39f5b2')) {
      api.createRecord('3c39f5b2', component.options)
    } else {
      api.reload('3c39f5b2', component.options)
    }
    module.hot.accept("./atribuicao-estrategia.vue?vue&type=template&id=3c39f5b2&scoped=true&", function () {
      api.rerender('3c39f5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/atribuicao-estrategia.vue"
export default component.exports